import React from 'react'
import './Infos.css'
import Nav from '../Home/Nav/Nav.js';
import { FaLongArrowAltLeft } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
const Infos = () => {
     const { t, i18n } = useTranslation();
          
              const changeLanguage = (e) => {
                i18n.changeLanguage(e.target.value);
            };
    return (
        <div>
            <div className='Infos' >
                <div className='pt-10' ><Nav /></div>
                <div className='Infos_all'>
                    <div className='Infos_titles'>
                        <h1>{t("histoire.title")}</h1>
                    </div>

                    <div className='buttons' >
                        <RouterLink to="/" className='Infos_button2'>
                            <FaLongArrowAltLeft />
                            {t("histoire.button")}
                        </RouterLink>
                    </div>
                </div>
            </div>
            <div className='info_content plf' >
                <br></br>
                <p className='plf' ><strong>{t("histoire.t1")}</strong></p>
                <p className='plf' >{t("histoire.p1")}
                </p><br></br>
                <p className='plf' ><strong>{t("histoire.t2")}</strong></p>
                <p className='plf' >{t("histoire.p2")}<br></br>
                    <span><strong>{t("histoire.t3")}</strong> <br></br>
                    {t("histoire.p3")}<br></br>
                    {t("histoire.p3b")}</span>
                </p><br></br>
                <p className='plf' ><strong>{t("histoire.t4")}</strong></p>
                <p className='plf'  >{t("histoire.p4")}<br></br>
                    <span>{t("histoire.t5")}<br></br>
                    {t("histoire.p5")}<br></br>
                    {t("histoire.p5b")} <br></br></span>
                    {t("histoire.p5c")}<br></br>
                    {t("histoire.p5d")}</p><br></br>
            </div>
        </div>
    )
}

export default Infos;
